import styled from 'styled-components';
import { body2, colors, link, spacing } from 'ui/theme';

export const JourneyConversionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.base};
  align-self: stretch;
`;

export const JourneyConversionsLink = styled.a`
  ${link};
  ${body2};
  color: ${colors.link};
`;

export const JourneyConversionsBodyWrapper = styled.div`
  display: flex;
  padding: ${spacing.plusHalf};
  width: 100%;
  align-items: flex-start;
  gap: ${spacing.plusHalf};

  align-self: stretch;

  border-radius: 4px;

  background: ${colors.backgroundSecondary};
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
